/* eslint-disable camelcase */
import 'animate.css';

import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import Text from '../../../react-components/Text';
interface OnboardingImageRightComponentProps {
  titleIntlId?: string;
  descriptionIntlId?: string;
  illustration: string;
}
export const OnboardingImageRightComponent = ({
  titleIntlId,
  descriptionIntlId,
  illustration,
}: OnboardingImageRightComponentProps) => {
  return (
    <Grid
      item
      display="flex"
      flexDirection="column"
      maxWidth="700px"
      className={`animate__animated animate__fadeIn animate__faster`}
    >
      <Grid container maxWidth={400} alignItems="left" flexDirection={`column`}>
        <Grid item>
          <Text variant="body-large" isBold intlId={titleIntlId} style={{ color: RoutalPalette.neutral02n }} />
        </Grid>

        <VSpacer medium />

        <Grid item>
          <Text variant="body" intlId={descriptionIntlId} style={{ color: RoutalPalette.neutral02n }} />
        </Grid>
      </Grid>
      <VSpacer large />
      <img src={illustration} alt={illustration} style={{ width: `100%` }} />
    </Grid>
  );
};
